<script setup>
import {defineProps, defineEmits, toRefs, ref, computed, watch} from "vue"
import competitionServices from "@/services/competitionServices";
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";
import axios from "axios";
import ProjectVoteComponent from "@/views/ToExpert/ProjectVoteComponent.vue";

let tab = ref(0);

const props = defineProps({
  project: {
    required: true
  },
  projectInfo: {},
  currentUserEmail: {},
  isDataUpdating: {
    type: Boolean,
    default: false
  },
  command: {}
});
const {project, command} = toRefs(props);


const emit = defineEmits(['addToFavorite', 'toggleFavorite'])

function addToFavorite() {
  emit('addToFavorite')
}

function toggleFavorite() {
  emit('toggleFavorite')
}

function getUserAvatar(avatar) {
  if (avatar && avatar.length > 0) {
    return 'https://script.moviestart.ru/uploads/images/' + avatar;
  } else {
    return 'https://script.moviestart.ru/images/anonym.png';
  }
}

function getTourName($tourNumber) {
  return competitionServices.getTourName($tourNumber);
}

const isOrganizator = computed(() => {
  return window.isOrganizatorRole === '1' ? true : false;
})
const isExpert = computed(() => {
  return window.isExpertRole === '1' ? true : false;
})

function getProjectAvatar(avatar) {
  return ImageService.getProjectImagePath(avatar);
}

async function addToFavoriteOnly() {
  try {

    await axios.post('/ajax/expert/add_favorit_project', null, {
      params: {
        state: !props.project.is_favorite_only,
        projectInfoId: props.projectInfo.id
      }
    })
  } catch (error) {
    alert('Ошибка получения данных: ' + error);
  }
}

</script>

<template>
	<!--		https://127.0.0.1:8000/project/show_expert/5489/1/77-->
	<!--		pr@moviestart.ru -->
  <div class="columns">
    <div class="column">
      <div class="header_title">{{ project.name }}</div>
      <div v-if="projectInfo" class="project_tour_text">{{ getTourName(projectInfo.competition.tour) }}</div>
    </div>
  </div>
	

  <template v-if="projectInfo.category.name === 'Нейросетевое кино'">
    <div class="columns">
      <div class="column">
        <div class="gray_box">
          <div class="columns">
            
            <div class="column" v-if="project.project_data.year_relise">
              <p class="countries_block__title">Год выпуска</p>
              <p class="countries_block__sub">{{ project.project_data.year_relise || 'Не указано' }}</p>
            </div>

            <div class="column" v-if="project.project_data.mounth_relise">
              <p class="countries_block__title">Месяц выпуска</p>
              <p class="countries_block__sub">{{ project.project_data.mounth_relise || 'Не указано' }}</p>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <p class="countries_block__title">Продолжительность фильма</p>
              <p class="countries_block__sub">{{ project.chronometr || 'Не указано' }} мин</p>
            </div>
            <div class="column" v-if="project.project_data.zhanr">
              <p class="countries_block__title">Жанр</p>
              <p class="countries_block__sub">{{ project.project_data.zhanr.join(', ') }} </p>
            </div>

          </div>
        </div>

        <div class="gray_box author_box">
          <div class="columns author_columns" v-if="project.user">
            <div class="column author_columns_left">
              <div class="countries_block__title">Автор</div>
              <div class="countries_block__sub"><a :href="'/current-user/'+project.user.id+'/part'"
                                                   target="_blank">{{ project.user.fio }}</a></div>
            </div>
            <div class="column author_columns_right">
              <a target="_blank" :href="'/current-user/'+project.user.id+'/part'" class="button4_white">Подробнее
                об авторе</a>
            </div>
          </div>
        </div>
        <template
            v-if="currentUserEmail === 'nigmatullina.a.h@mail.ru' || currentUserEmail === 'yantilina.lili@yandex.ru' || currentUserEmail === 'kartushin@me.com'">
          <div class="column">
            <p style="display: flex">
              <input style="margin-right: 12px;" type="checkbox" id="addToFavorite" @click="addToFavoriteOnly"
                     :checked="project.is_favorite_only"><label for="addToFavorite">Добавить проект в избранное</label>
            </p>
          </div>
        </template>


      </div>
    </div>
    <div class="tabs_wrapper">
      <div class="tab_item" :class="{ 'is_active': tab === 0 }" @click="tab = 0">
        Общая информация
      </div>
      <div class="tab_item" :class="{ 'is_active': tab === 1 }" @click="tab = 1">
        Команда
      </div>
    </div>
    <div class="tab_content" v-show="tab === 0">
	    <div class="columns">
		    <div class="column">
	        <div class="columns" v-if="project.annotation">
	          <div class="column left_column_par">
	            <span class="par_title">Описание фильма/работы</span>
	          </div>
	          <div class="column right_column_par">
	            <div class="par_text" v-html="project.annotation"></div>
	          </div>
	        </div>
			    
	        <div class="columns" v-if="project.video_link">
	          <div class="column left_column_par">
	            <span class="par_title">Закрытая ссылка на просмотр</span>
	          </div>
	          <div class="column right_column_par">
	            <div class="par_text"><a :href="project.video_link" target="_blank">{{ project.video_link }}</a></div>
	          </div>
	        </div>
			    
	        <div class="columns" v-if="project.tagline">
	          <div class="column left_column_par">
	            <span class="par_title">Закрытая ссылка на скачивание фильма</span>
	          </div>
	          <div class="column right_column_par">
	            <div class="par_text"><a :href="project.tagline" target="_blank">{{ project.tagline }}</a></div>
	          </div>
	        </div>
	
	        <div class="columns" v-if="project.project_data && project.project_data.ai_techs">
	          <div class="column left_column_par">
	            <span class="par_title">Какие технологии применялись при производстве фильма</span>
	          </div>
	          <div class="column right_column_par">
	            <div class="par_text">{{ project.project_data.ai_techs}}</div>
	          </div>
	        </div>
			    
			    
	        <div class="columns" v-if="project.film_language">
	          <div class="column left_column_par">
	            <span class="par_title">На каком языке снят фильм (видеоролик, клип)</span>
	          </div>
	          <div class="column right_column_par">
	            <div class="par_text">{{ project.film_language }}</div>
	          </div>
	        </div>
			    
	        <div class="columns" v-if="project.project_data && project.project_data.premiera">
	          <div class="column left_column_par">
	            <span class="par_title">Премьерность фильма</span>
	          </div>
	          <div class="column right_column_par">
	            <div class="par_text">{{ project.project_data.premiera }}</div>
	          </div>
	        </div>
			    
	        <div class="columns" v-if="project.motivation">
	          <div class="column left_column_par">
	            <span class="par_title">Мотивация</span>
	          </div>
	          <div class="column right_column_par">
	            <div class="par_text">{{ project.motivation }}</div>
	          </div>
	        </div>
	        <div class="columns" v-if="project.film_rights">
	          <div class="column left_column_par">
	            <span class="par_title">Кому принадлежат права на фильм</span>
	          </div>
	          <div class="column right_column_par">
	            <div class="par_text">{{ project.film_rights }}</div>
	          </div>
	        </div>
	        <div class="columns" v-if="project.music_rights">
	          <div class="column left_column_par">
	            <span class="par_title">Кому принадлежат права на музыку, использованную в фильме (видеоролике, клипе)</span>
	          </div>
	          <div class="column right_column_par">
	            <div class="par_text">{{ project.music_rights }}</div>
	          </div>
	        </div>
	        <div class="columns" v-if="project.country">
	          <div class="column left_column_par">
	            <span class="par_title">Страна</span>
	          </div>
	          <div class="column right_column_par">
	            <div class="par_text">{{ project.country }}</div>
	          </div>
	        </div>
	        <div class="columns" v-if="project.city">
	          <div class="column left_column_par">
	            <span class="par_title">Город</span>
	          </div>
	          <div class="column right_column_par">
	            <div class="par_text">{{ project.city }}</div>
	          </div>
	        </div>
	        <div class="columns" v-if="project.region">
	          <div class="column left_column_par">
	            <span class="par_title">Регион</span>
	          </div>
	          <div class="column right_column_par">
	            <div class="par_text">{{ project.region }}</div>
	          </div>
	        </div>
	        <div class="columns" v-if="project.film_rights_phone">
	          <div class="column left_column_par">
	            <span class="par_title">Номер телефона</span>
	          </div>
	          <div class="column right_column_par">
	            <div class="par_text">{{ project.film_rights_phone }}</div>
	          </div>
	        </div>
	        <div class="columns" v-if="project.film_rights_email">
	          <div class="column left_column_par">
	            <span class="par_title">Email</span>
	          </div>
	          <div class="column right_column_par">
	            <div class="par_text">{{ project.film_rights_email }}</div>
	          </div>
	        </div>
		    </div>
	    </div>
    </div>
    <div class="tab_content" v-show="tab === 1">
      <div class="team-section" v-if="project.project_data">
        <!-- Авторы -->
        <div v-if="project.project_data.authorScenarios && project.project_data.authorScenarios.length">
          <h3>Авторы</h3>
          <div v-for="(author, index) in project.project_data.authorScenarios" :key="'author-' + index">
            <p><strong>{{ author.fio }}</strong></p>
            <p v-if="author.phone">Телефон: {{ author.phone }}</p>
            <p v-if="author.email">Email: {{ author.email }}</p>
            <p v-if="author.bio">Биография: {{ author.bio }}</p>
            <p v-if="author.birthday">Дата рождения: {{ author.birthday }}</p>
          </div>
        </div>

        <!-- Продюсеры -->
        <div v-if="project.project_data.producers && project.project_data.producers.length">
          <h3>Продюсеры</h3>
          <div v-for="(producer, index) in project.project_data.producers" :key="'producer-' + index">
            <p><strong>{{ producer.fio }}</strong></p>
            <p v-if="producer.phone">Телефон: {{ producer.phone }}</p>
            <p v-if="producer.email">Email: {{ producer.email }}</p>
            <p v-if="producer.bio">Биография: {{ producer.bio }}</p>
            <p v-if="producer.birthday">Дата рождения: {{ producer.birthday }}</p>
          </div>
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <div class="columns">
      <div class="column is-narrow">
        <div class="project_afisha">
          <ImageRender :src="getProjectAvatar(project.afisha)"></ImageRender>
        </div>
      </div>
      <div class="column">
        <div class="gray_box">
          <div class="columns">
            <div class="column">
              <p class="countries_block__title">Формат</p>
              <template v-if="project.zhanr && project.zhanr.length">
                <p class="countries_block__sub" v-for="genre in project.zhanr" :key="genre">{{ genre }}</p>
              </template>
              <p class="countries_block__sub" v-else>Не указано</p>
            </div>
            <div class="column">
              <p class="countries_block__title">Год выпуска</p>
              <p class="countries_block__sub">{{ project.publish_year || 'Не указано' }}</p>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <p class="countries_block__title">Продолжительность фильма</p>
              <p class="countries_block__sub">{{ project.chronometr || 'Не указано' }} мин</p>
            </div>
            <div class="column" v-if="project.project_data.zhanr">
              <p class="countries_block__title">Жанр</p>
              <p class="countries_block__sub">{{ project.project_data.zhanr.join(', ') }} </p>
            </div>
	          
          </div>
        </div>

        <div class="gray_box author_box">
          <div class="columns author_columns" v-if="project.user">
            <div class="column author_columns_left">
              <div class="countries_block__title">Автор</div>
              <div class="countries_block__sub"><a :href="'/current-user/'+project.user.id+'/part'"
                                                   target="_blank">{{ project.user.fio }}</a></div>
            </div>
            <div class="column author_columns_right">
              <a target="_blank" :href="'/current-user/'+project.user.id+'/part'" class="button4_white">Подробнее
                об авторе</a>
            </div>
          </div>
        </div>

          <ProjectVoteComponent
                  v-if="isExpert"
                  :project="project"
                  :is-data-updating="isDataUpdating"
                  @toggleFavorite="toggleFavorite"
                  @add-to-favorite="addToFavorite"
          ></ProjectVoteComponent>

        <template
            v-if="currentUserEmail === 'nigmatullina.a.h@mail.ru' || currentUserEmail === 'yantilina.lili@yandex.ru' || currentUserEmail === 'kartushin@me.com'">
          <div class="column">
            <p style="display: flex">
              <input style="margin-right: 12px;" type="checkbox" id="addToFavorite" @click="addToFavoriteOnly"
                     :checked="project.is_favorite_only"><label for="addToFavorite">Добавить проект в избранное</label>
            </p>
          </div>
        </template>


      </div>
    </div>

<!--    <div class="gray_box base_files">-->
<!--      <p class="countries_block__title">Основные файлы</p>-->
<!--      <div class="files_wrapper">-->

<!--      </div>-->
<!--    </div>-->

    <div class="tabs_wrapper">
      <div class="tab_item" :class="{ 'is_active': tab === 0 }" @click="tab = 0">
        Общая информация
      </div>
      <div class="tab_item" :class="{ 'is_active': tab === 1 }" @click="tab = 1">
        Команда
      </div>
    </div>

    <div class="tab_content" v-show="tab === 0">
      <div class="columns" v-if="project.production">
        <div class="column left_column_par">
          <span class="par_title">Производство</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text" v-html="project.production"></div>
        </div>
      </div>

      <div class="columns" v-if="project.annotation">
        <div class="column left_column_par">
          <span class="par_title">Краткая аннотация</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text" v-html="project.annotation"></div>
        </div>
      </div>

      <div class="columns" v-if="project.film_rights">
        <div class="column left_column_par">
          <span class="par_title">Кому принадлежат права на фильм (ролик, клип и т.д.)</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text">
            <p>ФИО: {{ project.film_rights }}</p>
            <p>Номер телефона: {{ project.film_rights_phone }}</p>
            <p>Email: {{ project.film_rights_email }}</p>
          </div>
        </div>
      </div>

      <div class="columns" v-if="project.video_link">
        <div class="column left_column_par">
          <span class="par_title">Закрытая ссылка для просмотра фильма</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text">
            <p><a :href="project.video_link" target="_blank">{{ project.video_link }}</a></p>
          </div>
        </div>
      </div>

      <div class="columns" v-if="project.tagline">
        <div class="column left_column_par">
          <span class="par_title">Закрытая ссылка на скачивание фильма</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text">
            <p><a :href="project.tagline" target="_blank">{{ project.tagline }}</a></p>
          </div>
        </div>
      </div>

<!--      <div class="columns" v-if="project.social_videolink">-->
<!--        <div class="column left_column_par">-->
<!--          <span class="par_title">Ссылка на фильм (видеоролик, клип), размещенный в социальных сетях</span>-->
<!--        </div>-->
<!--        <div class="column right_column_par">-->
<!--          <div class="par_text">-->
<!--            <p><a :href="project.social_videolink" target="_blank">{{ project.social_videolink }}</a></p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="columns" v-if="project.video_source">-->
<!--        <div class="column left_column_par">-->
<!--          <span class="par_title">Ссылка на исходные материалы для фильма</span>-->
<!--        </div>-->
<!--        <div class="column right_column_par">-->
<!--          <div class="par_text">-->
<!--            <p><a :href="project.video_source" target="_blank">{{ project.video_source }}</a></p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="columns" v-if="project.priority_social">-->
<!--        <div class="column left_column_par">-->
<!--          <span class="par_title">Ссылки на социальные сети-->
<!--                      проекта</span>-->
<!--        </div>-->
<!--        <div class="column right_column_par">-->
<!--          <div class="par_text">-->
<!--            <div>{{ project.priority_social }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="columns" v-if="project.project_command && project.project_command.command_photo">
        <div class="column left_column_par">
          <span class="par_title">Ссылка на кадры</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text">
            <p><a :href="project.project_command.command_photo" target="_blank">{{ project.project_command.command_photo }}</a></p>
          </div>
        </div>
      </div>

      <div class="columns" v-if="project.music_rights">
        <div class="column left_column_par">
          <span
              class="par_title">Кому принадлежат права на музыку, использованную в фильме (ролике, клипе и т.д.)</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text">{{ project.music_rights }}</div>
        </div>
      </div>

      <div class="columns" v-if="project.country">
        <div class="column left_column_par">
          <span class="par_title">Страна, которую вы представляете</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text">{{ project.country }}</div>
        </div>
      </div>

      <div class="columns" v-if="project.city">
        <div class="column left_column_par">
          <span class="par_title">Город, который вы представляете</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text">{{ project.city }}</div>
        </div>
      </div>

      <div class="columns" v-if="project.region">
        <div class="column left_column_par">
          <span class="par_title">Регион, который вы представляете</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text">{{ project.region }}</div>
        </div>
      </div>

      <div class="columns" v-if="project.country_town">
        <div class="column left_column_par">
          <span class="par_title">Страна и город, которые вы представляете</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text">{{ project.country_town }}</div>
        </div>
      </div>

      <div class="columns" v-if="project.film_language">
        <div class="column left_column_par">
          <span class="par_title">На каком языке фильм (ролик, клип и т.д.)</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text">{{ project.film_language }}</div>
        </div>
      </div>

<!--      <div class="columns" v-if="project.motivation">-->
<!--        <div class="column left_column_par">-->
<!--          <span class="par_title">Мотивация (несколько слов о том, почему для вас было важно рассказать именно эту историю)</span>-->
<!--        </div>-->
<!--        <div class="column right_column_par">-->
<!--          <div class="par_text">{{ project.motivation }}</div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="columns" v-if="project.project_command && project.project_command.inroles">
        <div class="column left_column_par">
          <span class="par_title">В ролях</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text">{{ project.project_command.inroles }}</div>
        </div>
      </div>

      <div class="columns" v-if="project.project_data && project.project_data.age_limit">
        <div class="column left_column_par">
          <span class="par_title">Возрастные ограничения</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text">{{ project.project_data.age_limit }}</div>
        </div>
      </div>

      <div class="columns" v-if="project.project_data && project.project_data.treiler">
        <div class="column left_column_par">
          <span class="par_title">Ссылка на трейлер фильма</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text"><a :href="project.project_data.treiler" target="_blank">{{ project.project_data.treiler }}</a></div>
        </div>
      </div>


      <div class="columns" v-if="project.project_data && project.project_data.premiera">
        <div class="column left_column_par">
          <span class="par_title">Премьерность фильма</span>
        </div>
        <div class="column right_column_par">
          <div class="par_text">{{ project.project_data.premiera }}</div>
        </div>
      </div>
    </div>

    <div class="tab_content" v-show="tab === 1">
      <div class="team-section" v-if="project.project_data">
        <!-- Авторы сценария -->
        <div v-if="project.project_data.authorScenarios && project.project_data.authorScenarios.length">
          <h3>Авторы сценария</h3>
          <div v-for="(author, index) in project.project_data.authorScenarios" :key="'author-' + index">
            <p><strong>{{ author.fio }}</strong></p>
            <p v-if="author.phone">Телефон: {{ author.phone }}</p>
            <p v-if="author.email">Email: {{ author.email }}</p>
            <p v-if="author.bio">Биография: {{ author.bio }}</p>
            <p v-if="author.birthday">Дата рождения: {{ author.birthday }}</p>
          </div>
        </div>

        <!-- Режиссеры -->
        <div v-if="project.project_data.regisers && project.project_data.regisers.length">
          <h3>Режиссеры</h3>
          <div v-for="(regiser, index) in project.project_data.regisers" :key="'regiser-' + index">
            <p><strong>{{ regiser.fio }}</strong></p>
            <p v-if="regiser.phone">Телефон: {{ regiser.phone }}</p>
            <p v-if="regiser.email">Email: {{ regiser.email }}</p>
            <p v-if="regiser.bio">Биография: {{ regiser.bio }}</p>
            <p v-if="regiser.birthday">Дата рождения: {{ regiser.birthday }}</p>
          </div>
        </div>

        <!-- Продюсеры -->
        <div v-if="project.project_data.producers && project.project_data.producers.length">
          <h3>Продюсеры</h3>
          <div v-for="(producer, index) in project.project_data.producers" :key="'producer-' + index">
            <p><strong>{{ producer.fio }}</strong></p>
            <p v-if="producer.phone">Телефон: {{ producer.phone }}</p>
            <p v-if="producer.email">Email: {{ producer.email }}</p>
            <p v-if="producer.bio">Биография: {{ producer.bio }}</p>
            <p v-if="producer.birthday">Дата рождения: {{ producer.birthday }}</p>
          </div>
        </div>

        <!-- Операторы -->
        <div v-if="project.project_data.operators && project.project_data.operators.length">
          <h3>Операторы</h3>
          <div v-for="(operator, index) in project.project_data.operators" :key="'operator-' + index">
            <p><strong>{{ operator.fio }}</strong></p>
            <p v-if="operator.birthday">Дата рождения: {{ operator.birthday }}</p>
          </div>
        </div>

        <!-- Композиторы -->
        <div v-if="project.project_data.compositors && project.project_data.compositors.length">
          <h3>Композиторы</h3>
          <div v-for="(compositor, index) in project.project_data.compositors" :key="'compositor-' + index">
            <p><strong>{{ compositor.fio }}</strong></p>
            <p v-if="compositor.birthday">Дата рождения: {{ compositor.birthday }}</p>
          </div>
        </div>

        <!-- Художники-постановщики -->
        <div v-if="project.project_data.hydozniks && project.project_data.hydozniks.length">
          <h3>Художники-постановщики</h3>
          <div v-for="(hydoznik, index) in project.project_data.hydozniks" :key="'hydoznik-' + index">
            <p><strong>{{ hydoznik.fio }}</strong></p>
            <p v-if="hydoznik.birthday">Дата рождения: {{ hydoznik.birthday }}</p>
          </div>
        </div>
      </div>
    </div>
  </template>

</template>

<style scoped>
.team-section > div {
    margin-bottom: 2rem;
}
h3 {
    margin-bottom: 1rem;
    font-weight: bold;
}
p {
    margin-bottom: 0.5rem;
}
</style>